import service from '@/utils/request'
// 获取评论
export function getComment(data) {
  return service({
    url: '/api/thirdLevelPage/comment/getComment',
    method: 'POST',
    data: data
  })
}
// 删除评论
export function removeComment(data) {
  return service({
    url: '/api/thirdLevelPage/comment/removeComment',
    method: 'POST',
    data: data
  })
}
// 删除二级评论
export function removeComment2nd(data) {
  return service({
    url: '/api/thirdLevelPage/comment/removeComment2nd',
    method: 'POST',
    data: data
  })
}
// 发表评论
export function submitComment(data) {
  return service({
    url: '/api/thirdLevelPage/comment/submitComment',
    method: 'POST',
    data: data
  })
}
// 发表二级评论
export function submitComment2nd(data) {
  return service({
    url: '/api/thirdLevelPage/comment/submitComment2nd',
    method: 'POST',
    data: data
  })
}
// 获取三级展示状态
export function getViewStatus(data) {
  return service({
    url: '/api/thirdLevelPage/comment/getViewStatus',
    method: 'GET',
    params: data
  })
}

